import { CheckCircleFillIcon, AlertFillIcon } from '@primer/octicons-react';
import React from 'react';
import Text from '../../Text/Text.js';
import classes from './InputValidation.module.css.js';

const validationIconMap = {
  success: CheckCircleFillIcon,
  error: AlertFillIcon
};
const InputValidation = ({
  children,
  id,
  validationStatus,
  sx
}) => {
  const IconComponent = validationStatus ? validationIconMap[validationStatus] : undefined;

  // TODO: use `text-caption-lineHeight` token as a custom property when it's available
  // then, we can move this all to CSS and use `calc` to get our height values
  const captionLineHeight = 16 / 12;
  const iconSize = 12;
  const iconBoxMinHeight = iconSize * captionLineHeight;
  return /*#__PURE__*/React.createElement(Text, {
    className: classes.InputValidation,
    "data-validation-status": validationStatus,
    sx: sx
  }, IconComponent ? /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classes.ValidationIcon,
    style: {
      '--inputValidation-iconSize': iconBoxMinHeight
    }
  }, /*#__PURE__*/React.createElement(IconComponent, {
    size: iconSize,
    fill: "currentColor"
  })) : null, /*#__PURE__*/React.createElement("span", {
    id: id,
    className: classes.ValidationText,
    style: {
      '--inputValidation-lineHeight': captionLineHeight
    }
  }, children));
};
InputValidation.displayName = "InputValidation";

export { InputValidation as default };
